import { HttpService } from '@skylab-shared/core';
import { KsefDocumentStatus } from '@skylab-shared/dataModel';
import { EventNotification, EventNotificationsServiceBase, EventNotificationType } from '../../event-notifications.service-base';
import { NotificatorBase } from '../notificator-base';

type DocumentKsefStatusEventData = EventNotification<{documentId: string, documentStatus: KsefDocumentStatus, ksefDocumentId: string}>;

export class DocumentKsefStatusNotificatorBase extends NotificatorBase<DocumentKsefStatusEventData, DocumentKsefStatusEventData[]> {
    protected readonly eventType: EventNotificationType = 'DocumentKsefStatusUpdated';

    public constructor(
        eventNotifications: EventNotificationsServiceBase,
        http: HttpService
    ) {
        super(eventNotifications, http);
    }

    protected async prepareDataAsync(events: DocumentKsefStatusEventData[]): Promise<DocumentKsefStatusEventData[]> {
        return Promise.resolve(events);
    }
}
